export function lastDigit(value: number | string, decimals: number): number {
  return parseFloat(
    decimals >= 0 ? parseFloat(String(value)).toFixed(decimals).slice(-1) : String(value).slice(decimals - 1, decimals)
  );
}

export function mathRound(value: number | string, decimals: number): number {
  return Math.round(parseFloat(String(value)) * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export function circularDistance(a: number, b: number): number {
  const diff = Math.abs(a - b);
  return Math.min(diff, 10 - diff);
}

export function onlyDist(a: number, b: number, dist: number, decimals: number): boolean {
  const factor = Math.pow(10, decimals);

  const ai = Math.round(a * factor);
  const bi = Math.round(b * factor);

  return ai + dist === bi || ai - dist === bi;
}
